import React, { Component } from 'react';
import { translate } from 'react-i18next';
import Highcharts from 'highcharts';

import Scoring from './Scoring';
import DashboardMap from './DashboardMap';
import Graph from './Graph';
import { NewBill } from './Bills/NewBill';
import { Geozones } from './Geozones';

@translate(['dashboard'], { wait: true })
export default class Dashboard extends Component {
  setHightchartsParameters() {
    const { t } = this.props;
    Highcharts.setOptions({
      lang: {
        months: t('dashboard:months'),
        shortMonths: t('dashboard:shortMonths'),
        weekdays: t('dashboard:weekdays'),
        rangeSelectorFrom: t('dashboard:rangeSelectorFrom'),
        rangeSelectorTo: t('dashboard:rangeSelectorTo'),
        rangeSelectorZoom: t('dashboard:rangeSelectorZoom'),
      },
      title: { text: false },
      exporting: { enabled: false },
      yAxis: {
        visible: false,
        labels: {
          style: {
            fontSize: '10px',
            color: '#000000',
            ogity: 0.5,
            'font-family': 'FormularLight',
          },
        },
      },
      legend: { enabled: false },
      credits: { enabled: false },
      tooltip: {
        shared: true,
        borderRadius: 0,
        borderWidth: 0,
        shadow: false,
        enabled: true,
        padding: 0,
        backgroundColor: 'none',
        headerFormat: '<b>{point.x}</b><br/>',
        useHTML: true,
        hideDelay: 50,
        positioner(boxWidth, boxHeight, point) { // eslint-disable-line func-names
          let tooltipX;
          if (point.plotX + boxWidth > this.chart.containerWidth) {
            tooltipX = point.plotX - boxWidth + this.chart.plotLeft;
            this.chart.container.querySelector('div.highcharts-tooltip').classList.remove('left');
            this.chart.container.querySelector('div.highcharts-tooltip').classList.add('right');
          } else if (point.plotX - boxWidth < 0) {
            tooltipX = point.plotX + this.chart.plotLeft;
            this.chart.container.querySelector('div.highcharts-tooltip').classList.remove('right');
            this.chart.container.querySelector('div.highcharts-tooltip').classList.add('left');
          } else {
            tooltipX = point.plotX - boxWidth / 2 + this.chart.plotLeft;
            this.chart.container.querySelector('div.highcharts-tooltip').classList.remove('right');
            this.chart.container.querySelector('div.highcharts-tooltip').classList.remove('left');
          }
          return {
            x: tooltipX,
            y: point.plotY - boxHeight,
          };
        },
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          pointPadding: -0.293,
          borderWidth: 0.85,
          minPointLength: 2,
          color: '#e5e5e5',
        },
      },
      xAxis: {
        lineColor: 'transparent',
        type: 'datetime',
        tickWidth: 0,
        tickPixelInterval: 10,
        minPadding: 0,
        maxPadding: 0,
        startOnTick: false,
        endOnTick: false,
        labels: {
          rotation: 0,
          align: 'center',
          formatter() { // eslint-disable-line func-names
            if (this.chart.pointCount > 31) {
              this.chart.container.classList.add('long');
              return Highcharts.dateFormat('%e %b', this.value).replace(/ /g, '<br />');
            } else { // eslint-disable-line no-else-return
              this.chart.container.classList.remove('long');
              if (this.isFirst || this.isLast) {
                return Highcharts.dateFormat('%e %b', this.value);
              } else { // eslint-disable-line no-else-return
                return Highcharts.dateFormat('%e', this.value);
              }
            }
          },
          style: {
            fontSize: '10px',
            color: '#000000',
            opacity: '0.5',
            textOverflow: 'clip',
            'font-family': 'FormularLight',
            width: '20px',
            'min-width': '20px',
          },
        },
      },
    });
  }
  render() {
    this.setHightchartsParameters();
    return (
      <div>
        <NewBill />
        <Scoring />
        <Geozones />
        <DashboardMap />
        <Graph />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js